import { useTranslation } from 'react-i18next';
import * as S from './styled';

export const ServiceGuarantee: React.FC<{ onLinkClick: (type: string) => void }> = ({
  onLinkClick,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <S.Title>{t('service_guarantee')}</S.Title>
      <S.Description
        dangerouslySetInnerHTML={{ __html: t('service_guarantee_text') }}
        onClick={(e) => onLinkClick((e.target as HTMLElement).id)}
      />
    </>
  );
};
